<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`设备【${activeInfo.devCode} ${activeInfo.devName}】计量校准记录`"
    width="1100px"
    height="700px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div class="table-main">
      <TableHeader @onRefresh="getTableData()">
        <el-button v-auth="'device:calculate'" type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" stripe border style="width: 100%" height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="calibrateBy" label="校准机构" header-align="center"></el-table-column>
        <el-table-column prop="certCode" label="校准证书编号" header-align="center"></el-table-column>
        <el-table-column prop="checkTime" label="校准日期" width="100" align="center"></el-table-column>
        <el-table-column prop="nxCheckTime" label="证书有效期至" width="100" align="center"></el-table-column>
        <el-table-column label="附件" width="260" header-align="center">
          <template v-slot="{ row }">
            <div v-for="(file, inex) in row.fileList" :key="inex">
              <el-link type="primary" :underline="false" :href="$imgUrl + file.filePath" target="_blank">
                {{ file.fileName }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template v-slot="{ row }">
            <el-link v-auth="'device:calculate'" type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link v-auth="'device:calculate'" type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>

    <!-- 新增/编辑 -->
    <AdjustEdit :visible.sync="editVisible" :deviceInfo="activeInfo" :activeId="activeRowId" @refresh="getTableData()" />
  </drag-dialog>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import AdjustEdit from './AdjustEdit';

import { getDeviceCalibrateList, deleteDeviceCalibrateById } from '@/api/device';

export default {
  components: { TableHeader, AdjustEdit },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchModel: {
        pageNum: 1,
        pageSize: 20
      },
      tableLoading: false,
      dataTotal: 0,
      tableData: [],
      editVisible: false,
      activeRowId: null
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeInfo.id) {
        this.getTableData();
      }
    }
  },
  methods: {
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      try {
        const { data } = await getDeviceCalibrateList({
          deviceId: this.activeInfo.id,
          ...this.searchModel
        });
        const tableData = data.list || [];
        this.tableData = tableData.map(item => {
          const fileNames = item?.fileName.split(',') || [];
          const filePaths = item?.filePath.split(',') || [];
          return {
            ...item,
            fileList: fileNames.map((fileName, index) => {
              return {
                fileName,
                filePath: filePaths[index]
              };
            })
          };
        });
        this.dataTotal = data.count;
      } finally {
        this.tableLoading = false;
      }
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？删除后将无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteDeviceCalibrateById({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  }
};
</script>

<style scoped>
.el-select,
.el-input,
.el-autocomplete {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
